\:host
    display: block
    height: 100%

.Disabled
    display: none !important

.ArticlesContainer
    width: 100%
    height: 100%
    display: flex
    flex: 1
    flex-direction: column
    align-items: center
    background: rgb($globalSettingsBackgroundPrimary)
    justify-content: space-between
    font-size: 14px
    color: inherit
    overflow: hidden
    box-sizing: border-box
    .ArticlesContentContainer
        height: 100vh
        width: 100%
        display: flex
        box-sizing: border-box
        overflow-y: auto
        overflow-x: hidden
    .NoScroll
        overflow: hidden !important
    .ArticlesContent
        min-height: 0px
        width: 100%
        padding: 0
        display: flex
        flex-direction: column
        flex-shrink: 0
        box-sizing: border-box
    .TabsContainer
        min-height: 100px
        width: 100%
        flex-shrink: 0

.NotFound
    font-weight: 400s

@media #{$tablet}
    .MobileOnly
        display: none

    .ArticleContainer
        padding-left: 30px
        padding-right: 30px
        padding-top: 20px
        flex-direction: row
        align-items: stretch
        .ArticleContainerContent
            flex: 1
            flex-direction: column
            align-items: center
